import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";
import { Sfx, SfxAPI, SfxData } from "../Sfx";
import { useSfxReducer } from "./SfxReducer";

//  CONTEXTS
export const SfxAPIContext = createContext({} as SfxAPI);
export const SfxDataContext = createContext({} as SfxData);

export const SfxProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("SfxProvider render");

  //  DATA REDUCER
  const { data, dispatch } = useSfxReducer();

  //  API
  const api = useMemo<SfxAPI>(() => {
    const mute = () => dispatch({ type: "setMute", isMuted: true });
    const unMute = () => dispatch({ type: "setMute", isMuted: false });
    const play = (sfx: Sfx) => dispatch({ type: "play", sfx });
    const loop = (sfx: Sfx) => dispatch({ type: "loop", sfx });

    return { mute, unMute, play, loop };
  }, [dispatch]);

  return (
    <SfxAPIContext.Provider value={api}>
      <SfxDataContext.Provider value={data}>{children}</SfxDataContext.Provider>
    </SfxAPIContext.Provider>
  );
};

//  CUSTOM HOOKS
export const useSfxAPI = () => useContext(SfxAPIContext);
export const useSfxData = () => useContext(SfxDataContext);
